import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useRouter } from 'next/router';
import { REDLFileTree, REDLStaticImages } from '../constants';

export const useGetFileTreeUrl = () => {
    const router = useRouter();
    const { getRedlPageMetadata } = useRedlMetadata(router.pathname);
    return (pathname = '', filename = 'redl-index.json') => {
        const { layoutURLHost } = getRedlPageMetadata(router.pathname);
        const pathnameSection = pathname ? `${pathname}/` : '';
        return REDLFileTree.replace('{layoutURLHost}', layoutURLHost)
            .replace('{path}', `${pathnameSection}${filename}`);
    };
};

export const useGetREDLStaticImageUrl = () => {
    return (pathname = '', filename = '') => {
        const pathnameSection = pathname ? `${pathname}/` : '';
        return REDLStaticImages.replace('{path}', `${pathnameSection}${filename}`);
    };
};